import TR from 'utils/TR';
import Header from 'components/header';
import T from 'utils/T';
import ex from 'utils/ex';
import ReportTabs from '../ReportTabs';
import DietSummary from './DietSummary';
import DietMealAnalysis from './DietMealAnalysis';
import DietFoodAnalysis from './DietFoodAnalysis';
import DietStatistics from './DietStatistics';
import PageContent from '../../PageContent';
import VBox from 'components/common/VBox';
import Division from 'components/common/Division';
import PageTitle from '../../PageTitle';

import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import DietRatio from './DietRatio';

import './ReportDiet.css';
import GuideButton from '../GuideButton';
import useReportMeal from 'hooks/communication/useReportMeal';
import React from 'react';

import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import { useSignal } from 'modules/Signals';

export default function ReportDiet(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const {
    requestReportMeal,
  } = useReportMeal();

  const signal = useSignal();

  const [data, setData] = Recoil.useRecoilState(AppStore.assets.data('ReportDiet'));
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportMeal({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    });
  }, [patient_no, period_end, period_start, requestReportMeal, setData]);

  React.useEffect(() => {
    if (!front) return;
    signal('ReportData', data, 'ReportDiet');
  }, [front, data, signal]);

  return (
    <div {...ex(['Page', 'ReportDiet'], rest)}>
      <PageContent>
        <VBox full>
          <Division>
            <DietSummary {...rest} {...{ mealData: data }} />
          </Division>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <DietRatio {...rest} {...{ mealData: data, duration: renderAll ? 0 : 1 }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <DietMealAnalysis {...rest} {...{ mealData: data }} />
            <DietFoodAnalysis {...rest} {...{ mealData: data }} />
          </Segment>
          <Segment {...{ direction: DIRECTION_VERTICAL }}>
            <DietStatistics {...rest} {...{ mealData: data, duration: renderAll ? 0 : 1 }} />
          </Segment>
          <GuideButton {...rest} {...{ type: 'diet' }} />
        </VBox>
      </PageContent>
    </div>
  );
}
